/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PublicationWithRelations } from '../../models/publication-with-relations';

export interface EditorGetPublications$Params {
}

export function editorGetPublications(http: HttpClient, rootUrl: string, params?: EditorGetPublications$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PublicationWithRelations>>> {
  const rb = new RequestBuilder(rootUrl, editorGetPublications.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PublicationWithRelations>>;
    })
  );
}

editorGetPublications.PATH = '/editor/publications';
